import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import validator from 'validator';
import { useAuth } from '../../../providers/auth_provider';

export default function EditUser({ userData, fetchUserData }) {
    const { token } = useAuth();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        status: '',
        phone_no: '',
    });

    useEffect(() => {
        if (userData) {
            setFormData({
                first_name: userData.first_name || '',
                last_name: userData.last_name || '',
                status: userData.status || '',
                phone_no: userData.phone_no || '',
            });
        }
    }, [userData]); // This will trigger when userData changes

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!validator.isMobilePhone(formData.phone_no)) {
        //     toast.error('Please enter a valid phone number');
        //     return;
        // }

        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/admin/user/${userData.id}/update`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            fetchUserData();
            document.getElementById('closeModal').click();
            toast.success('User updated successfully');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong');
        }
    };

    return (
        <div className="modal fade" id="editUser" tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-lg modal-simple modal-edit-user">
                <div className="modal-content">
                    <button
                        type="button"
                        id="closeModal"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                    <div className="modal-body p-0">
                        <div className="text-center mb-6">
                            <h4 className="mb-2">Edit User Information</h4>
                        </div>
                        <form id="editUserForm" className="row g-5" onSubmit={handleSubmit}>
                            <div className="col-12 col-md-6">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        id="modalEditUserFirstName"
                                        name="first_name"
                                        className="form-control"
                                        value={formData.first_name}
                                        onChange={handleChange}
                                        placeholder="First Name"
                                        required
                                    />
                                    <label htmlFor="modalEditUserFirstName">First Name</label>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        id="modalEditUserLastName"
                                        name="last_name"
                                        className="form-control"
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        placeholder="Last Name"
                                    />
                                    <label htmlFor="modalEditUserLastName">Last Name</label>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        type="text"
                                        id="modalEditUserPhone"
                                        name="phone_no"
                                        className="form-control"
                                        value={formData.phone_no}
                                        onChange={handleChange}
                                        placeholder="Phone Number"
                                        required
                                    />
                                    <label htmlFor="modalEditUserPhone">Phone Number</label>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-floating form-floating-outline">
                                    <select
                                        id="modalEditUserStatus"
                                        name="status"
                                        className="form-select"
                                        value={formData.status}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>Select Status</option>
                                        <option value="active">Active</option>
                                        <option value="pending">Inactive</option>
                                        <option value="suspended">Suspended</option>
                                    </select>
                                    <label htmlFor="modalEditUserStatus">Status</label>
                                </div>
                            </div>
                            <div className="col-12 text-center d-flex flex-wrap justify-content-center gap-4 row-gap-4">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                                <button
                                    type="reset"
                                    className="btn btn-outline-secondary"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
